import React, { useEffect } from 'react';
import styles from './styles.module.css'
import { PiStopBold } from 'react-icons/pi'
import { CiPause1 } from 'react-icons/ci'
import { VscDebugStart } from 'react-icons/vsc'
import { useWebSocket } from '../../Utils/WebSocketContext';
import { useState } from 'react';
import PropTypes from 'prop-types'
import { BreathAPIs } from '../../APIs/BreathAPIs';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';

const SesssionControl = ({ selectedBooking, jwt, edrvID }) => {
  const webSocket = useWebSocket();
  const [connectorStatus, setConnectorStatus] = useState(selectedBooking ? selectedBooking.connector.status : null);
  const [chargerStatus, setChargerStatus] = useState(selectedBooking ? selectedBooking.charger.chargerStatus : null);
  const [bookingStatus, setBookingStatus] = useState(selectedBooking ? selectedBooking.bookingStatus : null);
  const [isCharging, setIsCharging] = useState(selectedBooking ? selectedBooking.isSessionActive : null);
  const [chargerAvailability, setChargerAvailability] = useState(selectedBooking ? selectedBooking.charger.chargerAvailability : null);
  const [bookingEnded, setBookingEnded] = useState(selectedBooking ? selectedBooking.bookingEnded : null);
  const [isSubmittingStart, setIsSubmittingStart] = useState(false);
  const [isSubmittingStop, setIsSubmittingStop] = useState(false);
  const [isSubmittingPause, setIsSubmittingPause] = useState(false);
  const [isSessionCount, setIsSessionCount] = useState(selectedBooking?.sessions?.length > 0 ? false : true);
  const [transactionState, setTransactionState] = useState(selectedBooking?.remoteTransactionStatus[selectedBooking?.remoteTransactionStatus?.length - 1])
  const [edrvSessionID, setEdrvSessionID] = useState('')
  const [showStopConfirmation, setShowStopConfirmation] = useState(false)
  console.log("Selected booking in session control", selectedBooking)

  useEffect(() => {
    if (webSocket) {
      webSocket.addEventListener('message', function (event) {
        // console.log("Event", event)
        if (JSON.parse(event.data).type === "chargestation.connector_status.updated") { // Connector status Charging.
          // console.log("condition: ", chargerId === JSON.parse(event.data).data.connectors[0].meta_data.breatheID)
          // console.log("status: ", JSON.parse(event.data).data.connectors[0].status)
          // console.log(chargerId)
          // console.log(JSON.parse(event.data).data.connectors[0].meta_data.breatheID)
          for (let i = 0; i < JSON.parse(event.data).data.connectors.length; i++) {
            if (selectedBooking.connector._id === JSON.parse(event.data).data.connectors[i].meta_data.breatheConnectorId) {
              setConnectorStatus(JSON.parse(event.data).data.connectors[i].status)
            }
          }

        }
        if (JSON.parse(event.data).type === "chargestation.online") {
          if (selectedBooking.charger._id === JSON.parse(event.data).data.connectors[0].rate.meta_data.breatheID) {
            setChargerStatus("Online")
          }
          // console.log(JSON.parse(event.data));
        }
        if (JSON.parse(event.data).type === "chargestation.offline") {
          if (selectedBooking.charger._id === JSON.parse(event.data).data.connectors[0].rate.meta_data.breatheID) {
            setChargerStatus("Offline")
          }
          // console.log(JSON.parse(event.data));
        }
        if (JSON.parse(event.data).type === "session.ended") {
          sessionCount()
        }
        if (JSON.parse(event.data).type === "session.started") {
          sessionCount()
          // let eventData = JSON.parse(event.data)
          // if (edrvSessionID === eventData.data._id) {
          //   console.log("inside")
          //   setTransactionState("Accepted")
          // }
        }
      })
    }
    sessionCount();
  }, [isCharging, bookingEnded, connectorStatus, chargerStatus])


  const sessionCount = async () => {
    if (selectedBooking._id !== "") {

      const getBookingRes = await BreathAPIs.getBooking(selectedBooking._id)
      let transactionLength = getBookingRes.data.remoteTransactionStatus.length
      setIsCharging(getBookingRes.data.isSessionActive)
      setEdrvSessionID(getBookingRes.data.currentSessionEdrvID)
      setBookingEnded(getBookingRes.data.bookingEnded)

      //   setBookingEnergy(getBookingRes.data.utilizedEnergy)
      //   setConsumedEnergy(bookingEnergy)

      setIsSessionCount(getBookingRes.data.sessions.length > 0 ? false : true)
      setBookingStatus(getBookingRes.data.bookingStatus);
      setTransactionState(getBookingRes.data.remoteTransactionStatus[transactionLength - 1])
    }
  }

  const handleStopModalClose = () => setShowStopConfirmation(false)
  const handleConfirmStop = () => {
    handleStop();
    handleStopModalClose();
  }

  const handleStart = async () => {
    try {
      const sessionDuration = (new Date(selectedBooking?.endTime) - new Date()) / (1000 * 60) // session duration in minutes.

      //   countdownInterval && clearInterval(countdownInterval);

      setIsSubmittingStart(true)
      setTransactionState("Loading")
      const session = {
        connector: selectedBooking?.charger?.connectionServer === "CSMS_BREATHE" ?
          selectedBooking.connector?.csmsBreatheID :
          selectedBooking.connector?.edrvID,
        userEDRV: selectedBooking.charger.connectionServer === "CSMS_BREATHE" ?
          selectedBooking?.user?.csmsBreatheID : selectedBooking?.user?.edrvID,
        target: { time: sessionDuration },
        bookingID: selectedBooking?._id,
        startActionCreatedAt: new Date()
      }

      const result = await BreathAPIs.startSession(jwt, session)
      if (result.data.message === "Session Started") {
        setTransactionState("Accepted-Disable")
        toast.success('Session Started.')
        setEdrvSessionID(result.data.session.edrvSessionID)
        setIsCharging(true);
        // setIsbookingCancelEnable(true)

      }
      if (result.data.message === "session start error") {
        toast.warning("Error in starting session, unplug and replug")
      }
      if (result.data.message === "server error") {
        toast.error("Couldn't start session try reconnecting charger.")
      }
      //   if (result.data.message === 'Suspended EV') {
      //     setSuspendedEVModal(true);
      //   }

    } catch (error) {
      toast.error("error starting session.")
      setTransactionState("Rejected")
    }
    setIsSubmittingStart(false)
  }

  const handleStop = async () => {
    try {
      setIsSubmittingStop(true)
      // if(isCharging){
      //   await handlePause(true)
      // }

      const stopActionCreatedAt = new Date()

      const res = await BreathAPIs.endBooking(selectedBooking._id, selectedBooking.user._id, stopActionCreatedAt)
      if (res.data.message === "Booking Ended.") {
        setIsCharging(false);
        setIsSubmittingStop(false);
        setBookingEnded(true);
        toast.success("Booking Ended Successfully.")
      }

      if (res.data.message === "Error in booking stop.") {
        setIsSubmittingStop(false)
        toast.error("Something went wrong while try to end the booking.")
      }
      if (res.data.message === "Booking Already Stopped") {
        setIsCharging(false);
        setIsSubmittingStop(false);
        setBookingEnded(true);
        toast.warning("Booking Already Stopped.")
      }
    } catch (error) {

    }

  }

  const handlePause = async (isStopClicked = false) => {
    try {
      isStopClicked === true ? setIsSubmittingPause(false) : setIsSubmittingPause(true)
      const pauseActionCreatedAt = new Date()
      const res = await BreathAPIs.stopSession(edrvSessionID, pauseActionCreatedAt)

      if (res.data.message === 'Session stopped') {
        setIsCharging(false);
        //   setIsChargeCompleted(true);
        setBookingEnded(false);
        if (!isStopClicked) {
          toast.success("Session Paused.")
        }

      }

      if (res.data.message === 'stop session api error') {
        toast.error("Error stopping session. ")
      }

      if (res.data.message === 'No Active session') {
        toast.warning("No active session to stop.")
        setIsCharging(false)
      }

    } catch (error) {

    }
    setIsSubmittingPause(false)
  }

  const startButtonDisabled = bookingStatus === 'rfid-authenticated' || (((connectorStatus === "Preparing" || connectorStatus === "Finishing") && chargerStatus === "Online" && chargerAvailability === true) ? false : true) || (isCharging || bookingEnded || isSubmittingStart || isSubmittingPause || isSubmittingStop) || connectorStatus === "SuspendedEV" || (isSessionCount === true && connectorStatus === 'Finishing') || (transactionState === "Accepted-Disable") || (transactionState === "Loading");
  // 
  // !startChargeEnabled ||

  const stopButtonDisabled = (!isCharging && isSessionCount) || bookingEnded || isSubmittingPause || isSubmittingStop || isSubmittingStart || (chargerStatus === "Offline" ? true : false) || connectorStatus === "SuspendedEV" || transactionState === "Accepted-Disable" || (transactionState === "Loading");

  const pauseButtonDisabled = !isCharging || bookingEnded || isSubmittingPause || isSubmittingStop || isSubmittingStart || ((connectorStatus !== "Charging") ? true : false) || (chargerStatus === "Offline" ? true : false) || connectorStatus === "SuspendedEV" || transactionState === "Accepted-Disable" || (transactionState === "Loading");

  // console.log("Start button disabled", startButtonDisabled,'stopButtonDisabled',stopButtonDisabled,'pauseButtonDisabled',pauseButtonDisabled, "isCharging", isCharging);
  return (
    <div className={styles.buttonMainContainer}>
      <div className={styles.buttonContainer}>
        <button
          className={`btn btn-success ${styles.roundedButton} `} //${isCharging ? styles.charging : ''}
          disabled={startButtonDisabled}    //preparing false
          onClick={handleStart}
        >

          {/* {(isSubmittingStart || transactionState === "Loading" ? true : false) && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                    {!(isSubmittingStart || transactionState === "Loading" ? true : false) &&  */}
          <VscDebugStart className={styles.iconButton}></VscDebugStart>
          {/* } */}
        </button>
        <button
          className={`btn btn-danger ${styles.roundedButton}`}
          disabled={stopButtonDisabled}
          onClick={() => setShowStopConfirmation(true)}
        >
          {/* ⏹️ */}
          {/* {isSubmittingStop && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                    {!isSubmittingStop && */}
          <PiStopBold className={styles.iconButton}></PiStopBold>
          {/* } */}
        </button>
        {
          !selectedBooking.nonReservable &&
          <button
            className={`btn btn-warning ${styles.roundedButton}`}
            disabled={pauseButtonDisabled}
            onClick={() => handlePause(false)}

          >
            {/* ⏹️ */}
            {/* {isSubmittingPause && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                    {!isSubmittingPause &&  */}
            <CiPause1 className={styles.iconButton}></CiPause1>
            {/* } */}
          </button>}
      </div>
      <span className={styles.statusText}>
        {connectorStatus}
      </span>

      <Modal show={showStopConfirmation} onHide={handleStopModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to stop booking?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleStopModalClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleConfirmStop}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </div>

  )
}
SesssionControl.propTypes = {
  user: PropTypes.string,
  timeFormatAmPm: PropTypes.bool,
  userID: PropTypes.string,
  location: PropTypes.string,
  type: PropTypes.string,
  edrvID: PropTypes.string,
  jwt: PropTypes.string,
  csmsID: PropTypes.string,
}
const mapStateToProps = state => ({
  user: state.auth && state.auth.user ? state.auth.user.firstName : null,
  timeFormatAmPm: state.auth && state.auth.user ? state.auth.user.timeFormatAmPm : false,
  userID: state.auth && state.auth.user ? state.auth.user._id : null,
  location: state.auth && state.auth.user ? state.auth.user.location._id : null,
  type: state.auth && state.auth.user ? state.auth.user.type : null,
  edrvID: state.auth && state.auth.user ? state.auth.user.edrvID : null,
  jwt: state.auth && state.auth.user ? state.auth.token : null,
  csmsID: state.auth && state.auth.user ? state.auth.user.csmsBreatheID : null
  //isAuthenticated : state.auth.isAuthenticated,
})

export default connect(mapStateToProps, {})(SesssionControl)